var chunkToChildrenMap = {
	"2138": [
		8592,
		1137,
		6066,
		501,
		9287,
		2791,
		2654,
		5138,
		8702,
		4445,
		2763,
		1193,
		6825,
		8527
	],
	"2642": [
		8592,
		6125,
		7762,
		1137,
		7810,
		5104,
		501,
		8466,
		2654,
		9975,
		6273,
		4736,
		2229,
		9756,
		7440,
		900,
		2138
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));